var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex pl15 pt10 pb10 aic"},[_c('div',{staticClass:"line flex0 bg_main mr5"}),_c('span',{staticClass:"ml5 mr5 flex0",class:['fs'+_vm.size]},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }